import { Box, Tooltip } from "@mui/material";

import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';
import FolderCopyOutlinedIcon from '@mui/icons-material/FolderCopyOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import ModeOutlinedIcon from '@mui/icons-material/ModeOutlined';
import PanToolOutlinedIcon from '@mui/icons-material/PanToolOutlined';
import PersonPinOutlinedIcon from '@mui/icons-material/PersonPinOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';
import ThumbUpOffAltOutlinedIcon from '@mui/icons-material/ThumbUpOffAltOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import configUrls from "../../config/configUrls";
import { ButtonPressDarCiencia } from "./processoDarCiencia/buttonPressDarCiencia";
import { ButtonPressProcessoFavoritar } from "./processoFavoritar/buttonPressProcessoFavoritar";


export const ProcessoFormViewMenu = () => {

    const navigate = useNavigate();






    return (

        <>

            <Box mt={0} p={0}
                sx={{
                    backgroundColor: "#f7f7f7",
                    padding: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    border: "1px solid #000",
                    borderRadius: "8px",
                    overflowX: 'auto',
                }}
            >




                <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="flex-start">
                    <Stack direction="row" spacing={0} flexWrap="wrap">
                        <Tooltip title="Adicionar Documento">
                            <IconButton
                                color="secondary"
                                size="large"
                                onClick={() => { navigate(configUrls.PROCESSO_GERAR_DOCUMENTO_CREATE_RT) }}

                            >
                                <AddCircleOutlineOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                        {/*
                        <Tooltip title="Iniciar Processo Relacionado">
                            <IconButton color="secondary" size="large">
                                <CachedOutlinedIcon />

                            </IconButton>
                        </Tooltip>
                      */}

                        <Tooltip title="Editar Processo">
                            <IconButton color="secondary" size="large"
                                onClick={() => {
                                    navigate(`${configUrls.PROCESSO_EDIT_LK}false`)
                                }}>

                                <ModeOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Acompanhamento Especial">
                            <IconButton color="secondary" size="large"
                                onClick={() => { navigate(configUrls.PROCESSO_ACOMPANHAMENTO_LIST_RT) }}>
                                <VisibilityOutlinedIcon />
                            </IconButton>
                        </Tooltip>


                        <Tooltip title="Dar Ciência" arrow>
                            <div>
                                <ButtonPressDarCiencia />
                            </div>
                        </Tooltip>

                        <Tooltip title="Enviar Processo">
                            <IconButton color="secondary" size="large"
                                onClick={() => { navigate(configUrls.PROCESSO_ENVIAR_LIST_RT) }}>
                                <SendOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Atualizar Andamento">
                            <IconButton color="secondary" size="large"
                                onClick={() => { navigate(configUrls.PROCESSO_HISTORICO_LIST_RT) }}>
                                <ReplayOutlinedIcon />
                            </IconButton>
                        </Tooltip>



                        <Tooltip title="Atribuir Processo">
                            <IconButton color="secondary" size="large"
                                onClick={() => { navigate(configUrls.PROCESSO_ATRIBUIR_LIST_RT) }}>

                                <PersonPinOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Adicionar aos Favoritos">
                            <div>
                                <ButtonPressProcessoFavoritar />
                            </div>
                        </Tooltip>
                        {/**
                        <Tooltip title="Duplicar">
                            <IconButton color="secondary" size="large">
                                <FolderCopyOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                         

                        <Tooltip title="Enviar por e-mail">
                            <IconButton color="secondary" size="large">
                                <AlternateEmailOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                        */}

                        <Tooltip title="Adicionar um bloco">

                            <IconButton color="secondary" size="large"
                                onClick={() => { navigate(configUrls.PROCESSO_BLOCO_LIST_RT) }}>

                                <CreateNewFolderOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Anotações">
                            <IconButton color="secondary" size="large"
                                onClick={() => { navigate(configUrls.PROCESSO_ANOTACAO_LIST_RT) }}>
                                <EditNoteOutlinedIcon />
                            </IconButton>

                        </Tooltip>

                        <Tooltip title="Sobrestar">
                            <IconButton color="secondary" size="large"
                                onClick={() => { navigate(configUrls.PROCESSO_SOBRESTAR_LIST_RT) }}>
                                <PanToolOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                        {/*
                        <Tooltip title="Anexar Processo">
                            <IconButton color="secondary" size="large">
                                <AttachFileOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                        */}

                        <Tooltip title="Concluir Processo">
                            <IconButton color="secondary" size="large"
                                onClick={() => { navigate(configUrls.PROCESSO_CONCLUIR_LIST_RT) }}>

                                <DoneOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Comentários">
                            <IconButton color="secondary" size="large"
                                onClick={() => { navigate(configUrls.PROCESSO_COMENTARIO_LIST_RT) }}>
                                <ChatOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Marcador">
                            <IconButton color="secondary" size="large"
                                onClick={() => { navigate(configUrls.PROCESSO_MARCADOR_LIST_RT) }}>
                                <LocalOfferOutlinedIcon />
                            </IconButton>
                        </Tooltip>


                        <Tooltip title="Definir Prazo">
                            <IconButton color="secondary" size="large"
                                onClick={() => { navigate(configUrls.PROCESSO_PRAZO_LIST_RT) }}
                            >
                                <AccessTimeOutlinedIcon />
                            </IconButton>
                        </Tooltip>

                        <Tooltip title="Voltar para Lista de Processos">
                            <IconButton color="secondary" size="large"
                                onClick={() => { navigate(configUrls.PROCESSO_LIST_RT) }}>
                                <LogoutOutlinedIcon />
                            </IconButton>
                        </Tooltip>


                        <Tooltip title="Pesquisar no processo">
                            <IconButton color="secondary" size="large">
                                <FindInPageOutlinedIcon />
                            </IconButton>
                        </Tooltip>


                        <Tooltip title="Deletar">
                            <IconButton aria-label="delete" color="secondary" size="large">
                                <DeleteIcon />
                            </IconButton>
                        </Tooltip>
                    </Stack>

                </Box>
            </Box>




        </>

    );

};
